import { render, staticRenderFns } from "./list-edit.vue?vue&type=template&id=45651080&scoped=true"
import script from "./list-edit.vue?vue&type=script&lang=js"
export * from "./list-edit.vue?vue&type=script&lang=js"
import style0 from "./list-edit.vue?vue&type=style&index=0&id=45651080&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45651080",
  null
  
)

export default component.exports